import { ITabAction } from '../../interfaces';
import Text from '../main/Text';

function TabAction({ icon, text, rightIcon }: ITabAction)
{
    return (
        <div style = {{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            {!rightIcon && icon}

            <Text {...{ text }} lineHeight = {'20px'} fontWeight = {700}/>

            {rightIcon && icon}
        </div>
    )
}

export default TabAction;